module.exports = __webpack_public_path__ + "static/media/pic8.f9c2a54d.jpg";